export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-11.jpg'),
        title: 'データ分析',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'データは利益成長を加速させ、デジタル経済時代の成功への道です',
      description: `<p style="font-size:1.05rem">MaesInfoは先進的なビッグデータ分析技術を活用して利益成長を加速し、デジタル経済時代での成功を支援します。情報の非対称性（情報の失敗）により、従来のビジネスモデルでは正確なユーザー需要や業務上の課題を把握できず、多くの無駄な損失が発生します。コンピュータの導入により、大量データの計算分析が可能となり、数千万ユーザーデータの収集と分析を通じて詳細なインサイトを抽出し、企業がより正確な判断と効果的な意思決定を行えるようにします。これにより企業はより高い利益成長を実現し、デジタル経済の頂点へと導かれます。</p>`
    },
    {
      title: '私たちの強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-11.jpg')+`)"></span>
      <span>MaesInfoは最先端のビッグデータ分析技術と豊富なビジネスサービス経験を活用し、市場調査を通じて関連データを収集・分析し、データ分析の有効性を評価・向上させます。これにより、市場動向をより正確に判断し、適切な生産・販売計画を立て、盲目的な意思決定や資源の無駄を避けることができます。低コストでビジネスを最大限に活用する支援を行います。</span>`
    }
  ]
}
